export function isEmbeddedMode(): boolean {
  if (typeof window === "undefined") return false;
  const isInIframe = window.parent !== window;
  const searchParams = new URLSearchParams(window.location.search);
  return isInIframe && searchParams.get("embedded") === "true";
}
